import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input } from "antd";
import { _uuid } from "../../utils/dataUtil";
import {
  req_add_pim_bunchLog_backFill_in,
  req_add_pim_bunchLog_backFill_out,
} from "../../api";
class BackFillSelfModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
    ip: PropTypes.string.isRequired,
  };
  state = {
    btnStatus: false,
    inputBunchIn: this.props.data.ClockInTimeMust,
    inputBunchOut: this.props.data.ClockOutTimeMust,
    firstRow: {
      Uid: "",
      StaffCode: "",
      BunchDate: "",
      BunchTime: new Date(),
      BunchMessage: "SUCCESS",
      BunchStatus: "BACKFILL",
      BunchType: "WEB",
      RecordIP: "0.0.0.0",
      NetworkStatus: "ALL",
      BackFillStatus: "APPLY",
    },
    lastRow: {
      Uid: "",
      StaffCode: "",
      BunchDate: "",
      BunchTime: new Date(),
      BunchMessage: "SUCCESS",
      BunchStatus: "BACKFILL",
      BunchType: "WEB",
      RecordIP: "0.0.0.0",
      NetworkStatus: "ALL",
      BackFillStatus: "APPLY",
    },
  };

  api_add_item_bunchin = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_backFill_in(item, token);
    return result.status;
  };

  api_add_item_bunchout = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_backFill_out(item, token);
    return result.status;
  };

  convertDateTime = (string_date, string_time) => {
    const year = string_date.substring(0, 4);
    const month = string_date.substring(4, 6);
    const day = string_date.substring(6, 8);
    const hours = string_time.substring(0, 2);
    const minutes = string_time.substring(2, 4);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { inputBunchIn, inputBunchOut } = this.state;
    const { StaffCode, ClockDate } = item;
    const firstrow = this.state.firstRow;
    const lastrow = this.state.lastRow;

    if (this.state.btnStatus) return;
    this.setState({ btnStatus: true });

    switch (tag) {
      case "BackFillFirstAndLast":
        firstrow.Uid = _uuid();
        firstrow.StaffCode = StaffCode;
        firstrow.BunchDate = ClockDate;
        firstrow.BunchTime = this.convertDateTime(ClockDate, inputBunchIn);
        firstrow.RecordIP = this.props.ip;

        lastrow.Uid = _uuid();
        lastrow.StaffCode = StaffCode;
        lastrow.BunchDate = ClockDate;
        lastrow.BunchTime = this.convertDateTime(ClockDate, inputBunchOut);
        lastrow.RecordIP = this.props.ip;

        this.api_add_item_bunchin(firstrow);
        this.api_add_item_bunchout(lastrow).then((result) => {
          if (result === "success") {
   
            message.success("補簽成功");
          } else {
    
            message.error("補簽失敗");
          }
        });
        break;
      case "BackFillFirst":
        firstrow.Uid = _uuid();
        firstrow.StaffCode = StaffCode;
        firstrow.BunchDate = ClockDate;
        firstrow.BunchTime = this.convertDateTime(ClockDate, inputBunchIn);
        firstrow.RecordIP = this.props.ip;
        console.log(firstrow);
        this.api_add_item_bunchin(firstrow).then((result) => {
          if (result === "success") {
            message.success("補簽成功");
          } else {
            message.error("補簽失敗");
          }
        });
        break;
      case "BackFillLast":
        lastrow.Uid = _uuid();
        lastrow.StaffCode = StaffCode;
        lastrow.BunchDate = ClockDate;
        lastrow.BunchTime = this.convertDateTime(ClockDate, inputBunchOut);
        lastrow.RecordIP = this.props.ip;
        console.log(lastrow);
        this.api_add_item_bunchout(lastrow).then((result) => {
          if (result === "success") {
            message.success("補簽成功");
          } else {
            message.error("補簽失敗");
          }
        });
        break;
      default:
    }
  };

  ////////
  render() {
    const { data } = this.props;
    const { inputBunchIn, inputBunchOut, btnStatus } = this.state;

    return (
      <Card title={"補簽日期：" + data.ClockDate}>
        {data.BunchTimeFirst === null ? (
          <>
            <div>
              簽到時間：{" "}
              <Input
                placeholder="簽到時間"
                style={{ width: 60, margin: "0 5px" }}
                value={inputBunchIn}
                onChange={(event) =>
                  this.setState({ inputBunchIn: event.target.value })
                }
              />
            </div>
            <div>
              簽退時間：{" "}
              <Input
                placeholder="簽退時間"
                style={{ width: 60, margin: "0 5px" }}
                value={inputBunchOut}
                onChange={(event) =>
                  this.setState({ inputBunchOut: event.target.value })
                }
              />
            </div>
            <button
              className="btn btn-info btn-sm"
              onClick={() =>
                this.handle_btn_event("BackFillFirstAndLast", data)
              }
              disabled={btnStatus}
            >
              同時補簽到及補簽退
            </button>
          </>
        ) : (
          <>
            您要
            <div>
              簽到時間：{" "}
              <Input
                placeholder="簽到時間"
                style={{ width: 60, margin: "0 5px" }}
                value={inputBunchIn}
                onChange={(event) =>
                  this.setState({ inputBunchIn: event.target.value })
                }
              />
            </div>
            <button
              className="btn btn-info btn-sm"
              onClick={() => this.handle_btn_event("BackFillFirst", data)}
              disabled={btnStatus}
            >
              補簽到
            </button>
            <p></p>
            還是
            <div>
              簽退時間：{" "}
              <Input
                placeholder="簽退時間"
                style={{ width: 60, margin: "0 5px" }}
                value={inputBunchOut}
                onChange={(event) =>
                  this.setState({ inputBunchOut: event.target.value })
                }
              />
            </div>
            <button
              disabled={btnStatus}
              className="btn btn-info btn-sm"
              onClick={() => this.handle_btn_event("BackFillLast", data)}
            >
              補簽退
            </button>
          </>
        )}
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(BackFillSelfModal);
